import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import config from '@config';

import { ENVIRONMENTS } from 'ui-kit';

import { resources } from '@assets/translations/resources';

let isDevelopmentEnv = false;
const { environment } = config;

if (environment === ENVIRONMENTS.LOCAL) {
  isDevelopmentEnv = true;
}

if (isDevelopmentEnv) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      preLoad: ['en-GB', 'nl-NL', 'de-DE', 'fr-FR'],
      lngs: ['en-GB', 'nl-NL', 'de-DE', 'fr-FR'],
      fallbackLng: (code) => {
        if (!code || code.length < 2) return ['en-GB'];

        switch (code.slice(0, 2)) {
          case 'nl':
            return ['nl-NL'];
          case 'fr':
            return ['fr-FR'];
          case 'de':
            return ['de-DE'];
          case 'en':
          default:
            return ['en-GB'];
        }
      },
      debug: true,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      resources,
      saveMissing: true,
      react: {
        useSuspense: false,
      },
      defaultNS: 'common',
      fallbackNS: 'common',
    });
} else {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: (code) => {
        if (!code || code.length < 2) return ['en-GB'];

        switch (code.slice(0, 2)) {
          case 'nl':
            return ['nl-NL'];
          case 'fr':
            return ['fr-FR'];
          case 'de':
            return ['de-DE'];
          case 'en':
          default:
            return ['en-GB'];
        }
      },
      lngs: ['en-GB', 'nl-NL', 'de-DE', 'fr-FR'],
      debug: false,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      resources,
      defaultNS: 'common',
      fallbackNS: 'common',
    });
}
export default i18n;
